import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  componentTotal: {
    id: 'course-authoring.block-type-utils.component-total',
    defaultMessage: 'Total',
    description: 'Total number of components',
  },
});

export default messages;
